import React from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import { useEffect } from "react";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import { finderCovenantByName } from "src/shared/global/helpers";
import { userState } from "src/store/user/userState";
import {
  filterSearchSelectedState,
  isChangeFormSearchState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "../../state/atoms";
import { covenantsState, isChangeCovenantFilterState } from "./state/atoms";
import SucursalIcon from "src/shared/icons/SucursalIcon";
import PrevisionIcon from "src/shared/icons/PrevisionIcon";

const AutocompletePrevision = ({ size = "small", styles }) => {
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const [isChangeCovenantFilter, setIsChangeCovenantFilter] = useRecoilState(
    isChangeCovenantFilterState
  );
  const covenants = useRecoilValue(covenantsState);
  const user = useRecoilValue(userState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );

  useEffect(() => {
    if (
      user.payload &&
      filterSearchSelected.covenantSelected.value === "" &&
      !isChangeCovenantFilter
    ) {
      setIsChangeFormSearch(true);
      const findCovenant = covenants.find(
        (x) => x.isaCodigoImed === user?.payload?.isaCodigoImed
      );
      setFilterSearchSelected({
        ...filterSearchSelected,
        covenantSelected: {
          ...filterSearchSelected.covenantSelected,
          value: findCovenant?.nombre || "",
          code: findCovenant?.codigo || null,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-prevision"
        text="Previsión (Opcional)"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-prevision"
        options={covenants.map((option) => `${option.nombre}`)}
        getOptionLabel={(option) => option || null}
        value={filterSearchSelected.covenantSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, newInputValue, reason) => {
          setIsChangeCovenantFilter(true);
          setIsChangeFormSearch(true);
          resetProfessionalsMatchCovenant();
          resetProfessionalsNoMatchCovenant();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              covenantSelected: {
                ...filterSearchSelected.covenantSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const finderCovenant = finderCovenantByName(
              covenants,
              newInputValue
            );
            setFilterSearchSelected({
              ...filterSearchSelected,
              covenantSelected: {
                ...filterSearchSelected.covenantSelected,
                value: newInputValue,
                code: finderCovenant?.codigo,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Previsión" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <PrevisionIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompletePrevision;
